import {Alert, Button, Spinner} from 'react-bootstrap';
import {FaTimes} from 'react-icons/fa';
import {chatErrorMessage} from '../chatUtils';
import {MessageComposer, MessageItem} from '../MessageComponents';
import useThreadReplies from '../hooks/useThreadReplies';

function ThreadMessage({message, conversation, currentUser, actions, renderActions}) {
    return (
        <MessageItem
            message={message}
            conversation={conversation}
            currentUser={currentUser}
            onEdit={actions.edit}
            onDelete={actions.remove}
            onReaction={actions.react}
            onRetry={actions.retry}
            renderActions={renderActions}
        />
    );
}

export default function ThreadPanel({conversation, root, currentUser, invalidation, onClose, onRootChanged, renderMessageActions}) {
    const thread = useThreadReplies({conversation, root, currentUser, invalidation, onRootChanged});
    return (
        <aside className="chat-thread" aria-label="Thread replies">
            <div className="chat-thread-header">
                <strong>Thread</strong>
                <button type="button" aria-label="Close thread" onClick={onClose}><FaTimes /></button>
            </div>
            <div className="chat-thread-root">
                <ThreadMessage message={root} conversation={conversation} currentUser={currentUser} actions={thread.actions} renderActions={renderMessageActions} />
            </div>
            <div className="chat-thread-replies">
                {thread.hasMore ? <Button size="sm" variant="link" onClick={thread.loadOlder}>Load older replies</Button> : null}
                {thread.loading ? <div className="chat-loading"><Spinner /></div> : null}
                {thread.replies.map(reply => (
                    <ThreadMessage key={reply.id} message={reply} conversation={conversation} currentUser={currentUser} actions={thread.actions} renderActions={renderMessageActions} />
                ))}
            </div>
            {thread.error ? <Alert variant="danger" className="m-2">{chatErrorMessage(thread.error)}</Alert> : null}
            <MessageComposer conversation={conversation} onSend={thread.sendReply} placeholder="Reply in thread" disabled={Boolean(root.deleted_at)} />
        </aside>
    );
}
